import { APIProvider } from '@vis.gl/react-google-maps';

const MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

/**
 * Single APIProvider for the whole app. Mounted once near the root so
 * Maps libraries are loaded exactly once and shared across pages.
 */
export default function MapsProvider({ children }) {
  if (!MAPS_KEY) {
    // Render children without Maps; consumers will fall back to placeholder UI.
    return children;
  }
  return (
    <APIProvider apiKey={MAPS_KEY} libraries={['places']}>
      {children}
    </APIProvider>
  );
}

export const HAS_MAPS = !!MAPS_KEY;
export const GSG_MAP_ID = 'gharsetgo_map';
